export default {
  conversation_dnd_message: "{name} DND'de",
  conversation_dnd_message_with_time:
    "{name}, {time, time, short}'(y)a/(y)e kadar DND'de",
  conversation_dnd_message_tooltip_content: '{name} bildirim almayacak',
};
